
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories-with-questions/[activitySlug]",
      function () {
        return require("private-next-pages/stories-with-questions/[activitySlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories-with-questions/[activitySlug]"])
      });
    }
  